// src/pages/admin/AddRecord.js
import React, { useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from '../../components/Modal';
import tableLabels from './TableLabels';
import tableConfigurations from './TableConfigurations';
import FieldRenderer from './FieldRenderer';
import UserInfo from '../../components/UserInfo';
import dropdownOptions from './dropdownOptions';
import './AddRecord.css';

function AddRecord() {
    const { tableName } = useParams();
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [modalMessage, setModalMessage] = useState('');
    const navigate = useNavigate();

    console.log(tableName);

    // Define configurations based on tableName
    const config = tableConfigurations[tableName];

    if (!config) {
        return <p>Invalid table name.</p>;
    }

    const { requiredFields, fieldLabels, fieldTypes } = config;

    // Handle form field changes
    const handleChange = (field, value) => {
        setFormData((prevData) => ({ ...prevData, [field]: value }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData);
        setErrors({});

        // Validate required fields
        const newErrors = {};
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = '⬆️ 此欄位為必填項 ⬆️';
            }
        });

        // if (Object.keys(newErrors).length > 0) {
        //     setErrors(newErrors);
        //     return;
        // }
        console.log("posting");
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/admin/${tableName}`,
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            if (response.ok) {
                setModalMessage('資料已成功新增。');
            } else {
                setModalMessage(`新增失敗。原因：${data.error}`);
            }
        } catch (error) {
            console.error('Error adding record:', error);
            setModalMessage('新增過程中發生錯誤。');
        }
    };

    return (
        <div className="page-content">
            <h2>
                <Link to="/admin">管理主頁</Link> ：
                <Link to={`/admin/${tableName}`}>{tableLabels[tableName]}</Link> ：
                新增
            </h2>
            <UserInfo />
            <form onSubmit={handleSubmit}>
                {Object.keys(fieldTypes).map((field) => {
                    // Determine if options should be passed
                    const fieldOptions = fieldTypes[field] === 'dropdown' && dropdownOptions[field]
                            ? dropdownOptions[field]
                            : undefined;

                    return (
                        <FieldRenderer
                            key={field}
                            field={field}
                            label={fieldLabels[field] || field}
                            type={fieldTypes[field]}
                            value={formData[field]}
                            required={requiredFields.includes(field)}
                            error={errors[field]}
                            onChange={handleChange}
                            options={fieldOptions} // Pass options if available
                        />
                    );
                })}
                <div className="form-actions">
                    <button type="submit" className="button button-m">
                        提交
                    </button>
                    <button
                        type="button"
                        className="button button-m"
                        onClick={() => navigate(-1)}
                    >
                        取消
                    </button>
                </div>
            </form>
            {modalMessage && (
                <Modal
                    message={modalMessage}
                    onClose={() => {
                        setModalMessage('');
                        navigate(-1);
                    }}
                />
            )}
        </div>
    );
}

export default AddRecord;
